// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-routes-articles-index-jsx": () => import("./../../../src/routes/articles/index.jsx" /* webpackChunkName: "component---src-routes-articles-index-jsx" */),
  "component---src-routes-i-18-n-redirect-index-jsx": () => import("./../../../src/routes/i18nRedirect/index.jsx" /* webpackChunkName: "component---src-routes-i-18-n-redirect-index-jsx" */),
  "component---src-routes-news-index-jsx": () => import("./../../../src/routes/news/index.jsx" /* webpackChunkName: "component---src-routes-news-index-jsx" */),
  "component---src-routes-page-index-jsx": () => import("./../../../src/routes/page/index.jsx" /* webpackChunkName: "component---src-routes-page-index-jsx" */),
  "component---src-routes-show-index-jsx": () => import("./../../../src/routes/show/index.jsx" /* webpackChunkName: "component---src-routes-show-index-jsx" */)
}

